import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReadOnlyField from '../../../../../common/components/ReadOnlyField';
import { LockIcon } from '../../../../../common/icons/redesignIcons';

import './RegVehicle.css';

@inject('translationsStore', 'moveinStore')
@observer
export default class RegVehicle extends Component {
  render() {
    const { translationsStore, moveinStore } = this.props;
    return (
      <div className="RegVehicle">
        <div className="RegVehicleHeader">
          <span className="mv-section-title">{translationsStore.translate('registration.vehicleData.title')}</span>
          <span className="mv-chip">
            <LockIcon size={11} color="currentColor" />
            {translationsStore.translate('movein.stepCheckData.fromRegionChip')}
          </span>
        </div>
        <div className="RegVehicleFields">
          <ReadOnlyField label={translationsStore.translate('registration.vehicleData.plate')} value={moveinStore.vehicle.license_plate} />
          <ReadOnlyField label={translationsStore.translate('registration.vehicleData.frame')} value={moveinStore.vehicle.vin} />
          <ReadOnlyField label={translationsStore.translate('registration.vehicleData.approval')} value={moveinStore.vehicle.fuel_type} />
          <ReadOnlyField label={translationsStore.translate('registration.vehicleData.equipment')} value={moveinStore.vehicle.environmental_class} />
          <ReadOnlyField label={translationsStore.translate('registration.vehicleData.category')} value={moveinStore.vehicle.category} />
        </div>
      </div>
    );
  }
}
